export default __webpack_public_path__ + "static/media/1.a9b2639f.png";